// extracted by mini-css-extract-plugin
var _1 = "amex-iaK5B";
var _2 = "cards-xGc1q";
var _3 = "diners-UYCXp";
var _4 = "discover-ChkYE";
var _5 = "icon-WTfHg";
var _6 = "jcb-QdIlR";
var _7 = "maestro-iCwDO";
var _8 = "mastercard-CXtT9";
var _9 = "unionpay-kvTa2";
var _a = "visa-ilwIQ";
export { _1 as "amex", _2 as "cards", _3 as "diners", _4 as "discover", _5 as "icon", _6 as "jcb", _7 as "maestro", _8 as "mastercard", _9 as "unionpay", _a as "visa" }
